// Simplified-Chinese localisation table, ported from cmd/hwgui/i18n.go.
// Mirrors the original tr/trf helpers: `tr(s)` returns the translation when
// present, otherwise the original English string. Dynamic content from the
// data file (peak names, audit messages) is already Chinese in the source
// data and is rendered as-is.

const zhCN: Record<string, string> = {
  // Window title
  "hwgui — HW chromatography viewer": "hwgui — HW 色谱数据查看器",

  // Toolbar / status
  "Open...": "打开…",
  "Beta — verify results against the original workstation software.":
    "测试版——请以原厂工作站软件的结果为准，谨慎使用。",
  "Designed for Ruineng GC3900 II, workstation software 3900-0914A (Qianpu remote-control build)":
    "适配 瑞能仪器 GC3900 二代，工作站软件 3900-0914A（千谱反控版）",
  "(no file loaded — click Open or drag a .hw file here)":
    "（尚未加载文件——点击「打开…」或拖拽 .hw 文件到此窗口）",
  "(no file loaded — click Open or drag .hw files here)":
    "（尚未加载文件——点击「打开…」或拖拽 .hw 文件到此窗口）",
  "Drop .hw files to load them": "松开以加载 .hw 文件",
  "ERROR: %s": "错误：%s",
  "%s   [PARSE ERROR: %s]": "%s   [解析错误：%s]",
  "%s   [%s, %d samples @ %s Hz]": "%s   [%s，%d 个采样点 @ %s Hz]",
  "Loaded files": "已加载文件",
  "Loaded files (%d)": "已加载文件（%d）",
  "Select %s": "选择 %s",
  "%d peaks": "%d 个峰",
  "parse error": "解析错误",
  "%s — Parse error: %s": "%s —— 解析错误：%s",
  "%s — %d samples, %d peaks": "%s —— %d 个采样点，%d 个峰",
  "Pattern search": "相似图谱搜索",
  Search: "搜索",
  "Query: %s": "查询来源：%s",
  query: "查询来源",
  "%d peaks, %s min": "%d 个峰，%s 分钟",
  "Similarity to %s: %s": "与 %s 的相似度：%s",
  "n/a": "不可用",

  // Tabs
  Overview: "概览",
  Peaks: "峰列表",
  Components: "组分表",
  Mid: "中间记录",
  Events: "检测事件",
  Audit: "审计日志",
  Report: "报告",
  Layout: "文件布局",
  Header: "文件头",

  // Empty-state messages
  "No signal to display.": "无信号可显示。",
  "No file loaded.": "未加载文件。",
  "Load error:\n%s": "加载失败：\n%s",
  "(no peaks decoded)": "（未解析出峰）",
  "(no calibration components in this file)": "（本文件未包含标定组分）",
  "(no audit-log entries)": "（无审计日志）",
  "(no mid records in this file)": "（本文件无中间记录）",
  "(not decoded)": "（未解码）",
  "(empty)": "（空）",
  "(not recorded)": "（未记录）",

  // Plot axes
  Chromatogram: "色谱图",
  "Retention time (min)": "保留时间（分钟）",
  "Signal (mV)": "信号强度（mV）",
  Intensity: "强度",

  // Peak / Component table headers
  "#": "#",
  Name: "名称",
  Flag: "峰标志",
  RT: "保留时间",
  Conc: "浓度",
  "Peak area": "峰面积",
  "Peak height": "峰高",
  FWHM: "半高峰宽",
  Width: "半高峰宽",
  "This is peak area percentage; HW.exe Data View calls it Concentration (Conc).":
    "此列是峰面积百分比；HW.exe 数据视图中称为浓度（Conc）。",

  // Audit / Report tabs
  Timestamp: "时间",
  Message: "消息",
  "Sample name: %s": "样品名称：%s",
  "--- Report header (CString 1) ---": "——— 报告头部（字符串 1）———",
  "--- Report footer (CString 2) ---": "——— 报告尾部（字符串 2）———",

  // Overview tab
  Magic: "文件标识",
  "Magic offset": "标识偏移",
  version: "版本",
  "%s  (%s)": "%s（%s）",
  "Sample count": "采样点数",
  "Sampling rate": "采样率",
  "%s Hz": "%s Hz",
  "Acquisition time": "采集时间",
  "Sample name": "样品名称",
  "Signal range": "信号范围",
  "%s … %s counts  (%s … %s mV)": "%s … %s 计数（%s … %s mV）",
  Amount: "进样量",
  Dilution: "稀释倍数",
  MidRecords: "中间记录",
  TailRecords: "尾部记录",
  "%s × 96 B = %s B": "%s × 96 字节 = %s 字节",
  "Tail pad block": "尾部填充块",
  "Trailing uint32": "末尾 uint32",
  "Audit entries": "审计条目",
  Sections: "字节区段",
  "Parse error": "解析错误",
  "Parse warnings": "解析警告",
  "%s sections, %s B total — see Layout tab": "%s 个区段，共 %s 字节——详见“文件布局”标签页",
  "First audit": "首条审计",
  "Last audit": "末条审计",

  // Mid tab
  "Word0 (u32)": "Word0（u32）",
  "F1 (f32)": "F1（f32）",
  "F2 (f32)": "F2（f32）",
  "F3 (f32)": "F3（f32）",

  // TailRecords tab
  "%s × 96-byte records.  Hover the W0..W23 cell to see each word reinterpreted as int32 / float32.":
    "共 %s 条 × 96 字节记录。鼠标悬停可查看每个 32 位字按 int32 / float32 重解读后的值。",
  Word0: "Word0",
  Word1: "Word1",
  Word10: "Word10",
  "Word11 (f32)": "Word11（f32）",
  "W0..W23 (uint32)": "W0..W23（uint32）",
  "(no tail records in this file)": "（本文件无尾部记录）",

  // Layout tab
  "%s sections, %s bytes total. Each row is one byte-range identified by the parser, in on-disk order. Click a row to reveal structured detail (when available) and a hex dump.":
    "共 %s 个区段，%s 字节。下表按文件字节顺序列出解析器识别出的所有区段，点击行可展开查看结构化详情（如有）及十六进制内容。",
  Offset: "偏移",
  Length: "长度",
  Tier: "可信级",
  Section: "区段",
  "Raw bytes": "原始字节",
  "\n\n— %s of %s bytes shown —": "\n\n——已显示 %s / %s 字节——",

  // Header tab
  Field: "字段",
  Value: "值",
  "U6 (TickUS?)": "U6（采样周期？）",
  "%d  (ignored — actual: %s Hz)": "%d  （已忽略——实际：%s Hz）",
  "%d  (%s)": "%d  （%s）",
  "%d  (= %s Hz)": "%d  （= %s Hz）",
  PreCount: "前置记录数",
  PeakCount: "峰记录数",
  MidCount: "中间记录数",
  AcquisitionTimestamp: "采集时间戳",
};

/** Translate a UI string. Falls back to the original. */
export function tr(s: string): string {
  return zhCN[s] ?? s;
}

/** Translate then substitute `%s`/`%d` placeholders sequentially. */
export function trf(format: string, ...args: unknown[]): string {
  const tmpl = tr(format);
  let i = 0;
  return tmpl.replace(/%[sd]/g, () => String(args[i++] ?? ""));
}
